/* eslint-disable no-param-reassign */
import TeamSettingsPaywallApi from '@/api/teamSettingsPaywall'
import sentry from '@/services/sentry'

const SET_LOADING = 'SET_LOADING'

const STORAGE_KEY_PREFIX = 'aha_team_settings_request_sent_'

const SSO_STORAGE_KEY_PREFIX = 'aha_team_sso_request_sent_'
const SSO_REQUEST_FOR = 'SSO'

const getStorageKey = (accountId, prefix = STORAGE_KEY_PREFIX) => `${prefix}${accountId}`

const isRequestSent = (accountId, prefix) => {
  try {
    return localStorage.getItem(getStorageKey(accountId, prefix)) === 'true'
  } catch {
    return false
  }
}

const markRequestSent = (accountId, prefix) => {
  try {
    localStorage.setItem(getStorageKey(accountId, prefix), 'true')
  } catch {
    // localStorage unavailable (AC-E02) — silently ignore
  }
}

const _state = {
  isLoading: false,
}

const getters = {
  isLoading: (state) => state.isLoading,
}

const actions = {
  async sendTeamSettingsFeatureRequestAction({ commit, rootState }, requestData) {
    try {
      commit(SET_LOADING, true)
      const result = await TeamSettingsPaywallApi.sendFeatureRequest(requestData)
      const prefix = requestData?.requestFor === SSO_REQUEST_FOR ? SSO_STORAGE_KEY_PREFIX : STORAGE_KEY_PREFIX
      markRequestSent(rootState.currentAccount.id, prefix)
      return result
    } catch (error) {
      sentry.captureException(error)
      throw error
    } finally {
      commit(SET_LOADING, false)
    }
  },
  checkRequestAlreadySent(_, accountId) {
    return isRequestSent(accountId)
  },
  checkSsoRequestAlreadySent(_, accountId) {
    return isRequestSent(accountId, SSO_STORAGE_KEY_PREFIX)
  },
}

const mutations = {
  [SET_LOADING](state, isLoading) {
    state.isLoading = isLoading
  },
}

const teamSettingsPaywall = {
  namespaced: true,
  state: _state,
  getters,
  actions,
  mutations,
}

export default teamSettingsPaywall
